import React, { useState, useEffect, useRef } from "react";

const CoachesDropdown = ({ coaches, selectedCoaches, onChange, isSecAdmin, theme = 'light' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                disabled ={isSecAdmin}
                className={`p-2 border-2 rounded-lg w-full text-left focus:border-blue-500 focus:outline-none transition-colors ${
                    theme === 'dark' 
                        ? 'bg-gray-700 border-gray-600 text-white' 
                        : 'bg-white border-gray-300 text-gray-900'
                }`}
            >
                {selectedCoaches.length ? selectedCoaches.join(', ') : 'Select Instructors'}
            </button>
            {isOpen && (
                <div className={`absolute z-[9999] bottom-full mb-1 w-full border rounded shadow-lg max-h-60 overflow-y-auto ${
                    theme === 'dark'
                        ? 'bg-gray-700 border-gray-600'
                        : 'bg-white border-gray-300'
                }`}>
                    {coaches.map(coach => (
                        <label key={coach.id} className={`flex items-center p-2 cursor-pointer ${
                            theme === 'dark'
                                ? 'hover:bg-gray-600 text-white'
                                : 'hover:bg-gray-100 text-gray-900'
                        }`}>
                            <input
                                type="checkbox"
                                value={coach.name}
                                checked={selectedCoaches.includes(coach.name)}
                                onChange={() => {
                                    const newSelectedCoaches = selectedCoaches.includes(coach.name)
                                        ? selectedCoaches.filter(c => c !== coach.name)
                                        : [...selectedCoaches, coach.name];
                                    onChange(newSelectedCoaches);
                                }}
                                className="mr-2"
                            />
                            <span>{coach.name}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CoachesDropdown;
